import { Flex, Typography, theme } from 'antd';
import { TableCellEcho, type Column } from '@/components/TableEcho';
import { PlatformSelectionTableEcho } from '@/routes/AudiencePage/charts/PlatformSelectionTableEcho';
import type { LocationData, LocationPlaysResponse, SelectedPlatform } from '@/types/api/location';
import { sortByPlatformDisplayOrder } from '@/utils/platformUtils';
import { getCountryName } from './countryUtils';

export const MapDataByPlatformEcho = ({
  data,
  selectedPlatform,
  handlePlatformChange,
}: {
  data: LocationPlaysResponse;
  selectedPlatform: SelectedPlatform<typeof data>;
  handlePlatformChange: (platform: SelectedPlatform<typeof data>) => void;
}) => {
  const { token } = theme.useToken();

  // TODO: return in API handler
  const getNthHighestValueLabel = (locationDistribution: LocationData[], rank: number = 1) => {
    const nthHighestValueObject = [...locationDistribution].sort(
      (firstLocation, secondLocation) => secondLocation.percentage - firstLocation.percentage
    )[rank - 1];

    return (
      <Flex align="center" gap={token.marginXXS}>
        <Typography.Text style={{ color: token.colorText }}>
          {getCountryName(nthHighestValueObject.label)}
        </Typography.Text>
        <Typography.Text
          style={{
            color: token.colorTextSecondary,
            fontSize: token.fontSizeSM,
            fontWeight: 300,
          }}
        >
          {nthHighestValueObject.percentage.toFixed(0)}%
        </Typography.Text>
      </Flex>
    );
  };

  const tableColumns: Column[] = [
    { key: 'radio', header: '', align: 'left' },
    { key: 'platform', header: 'Platform', align: 'left', className: 'px-2' },
    { key: 'top_location_1', header: '1st', align: 'left', className: 'px-2' },
    { key: 'top_location_2', header: '2nd', align: 'left', className: 'px-2' },
    { key: 'top_location_3', header: '3rd', align: 'left', className: 'px-2' },
  ];

  return (
    <Flex style={{ maxWidth: '100%' }}>
      <PlatformSelectionTableEcho<LocationPlaysResponse, LocationPlaysResponse['plays'][number]>
        idPrefix="location-data"
        data={sortByPlatformDisplayOrder(data)}
        selectedPlatform={selectedPlatform}
        handlePlatformChange={handlePlatformChange}
        tableColumns={tableColumns}
        renderDataCells={(rowData) => (
          <>
            <TableCellEcho align="left" className="px-2">
              {rowData.country_distribution[0]
                ? getNthHighestValueLabel(rowData.country_distribution, 1)
                : null}
            </TableCellEcho>
            <TableCellEcho align="left" className="px-2">
              {rowData.country_distribution[1]
                ? getNthHighestValueLabel(rowData.country_distribution, 2)
                : null}
            </TableCellEcho>
            <TableCellEcho align="left" className="px-2">
              {rowData.country_distribution[2]
                ? getNthHighestValueLabel(rowData.country_distribution, 3)
                : null}
            </TableCellEcho>
          </>
        )}
      />
    </Flex>
  );
};
